import methods from '@/services/methods'

export default {
  initiateTransfer (payload) {
    return methods.sendPost('transfers', payload, {restrictToast: true, disableButtons: true})
  },
  ifscDetails (ifsc) {
    return methods.sendGet(`ifscs/${ifsc.toUpperCase()}`, null, {restrictToast: true})
  },
  bankVerify (payload) {
    return methods.sendPost(`verify/bank_account`, payload)
  },
  upiVerify (payload) {
    return methods.sendPost(`verify/upi_id`, payload)
  },
  transferDetails (params) {
    return methods.sendGet(`transfers/new`, params)
  }
}
